import Toast from 'components/Shared/Toast';

export const errorMessage = {
  generic: (complement?: string) => `Ocorreu um erro ${complement}. Tente novamente`,
};

export default function errorHandler(err: any, message?: string) {
  if (err.message === 'Request failed with status code 403') {
    Toast.error(
      'Permissão Negada. O administrador desta conta não lhe concedeu privilégio para acessar este recurso',
      6000,
    );
  } else {
    Toast.error(message ?? err.message);
  }
}
